module.exports = __webpack_public_path__ + "static/media/KR.155e6788.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/KR.svg
// module id = 292
// module chunks = 0